import React from 'react';
import "../Styles/Footer.css";
const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-logo">
        <a href="/">
        <img className="logo" src="images/mainlogo.png" alt="logo" />
        </a>
        <p>Account is maintained by KALINGA RAMARAO</p>
        </div>
        <div className="footer-links">
          <ul>
            <li><a href="/">Home</a></li>
            <li><a href="/projects">Services</a></li>
            <li><a href="/about">About Us</a></li>
            <li><a href="/pricing">Pricing</a></li>
            <li><a href="/policies">Policies</a></li>
            <li><a href="/contact">Contact</a></li>
          </ul>
        </div>
        <div className="footer-contact">
          <p>Contact Us</p>
          <p>Instagram: @sr_techcreators_vizag</p>
          <p>Email: srtechcreators.vizag@gmail.com</p>
          <p>+91 6305877759</p>
          <p>+91 9642909195</p>
          <p>+91 7730020465</p>
        </div>
      </div>
      <div className="footer-bottom">
        <p>&copy; 2024 SR-Tech Creators. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
